$(document).ready(function () {
  $(window).on("resize", function (e) {
      checkScreenSize();
  });
  checkScreenSize();
  function checkScreenSize() {
    var newWindowWidth = $(window).width();
    if ($('.buy-buttons-fix-mobile')) {
      $(window).scroll(function () {
        var scroll = $(window).scrollTop();
        if (newWindowWidth >= 767) {
          $(".buy-buttons-fix-mobile").removeClass("sticky");
        }
        else {
          if ($(".mobile_sticky_target")[0].getBoundingClientRect().bottom < 0) {
              $(".buy-buttons-fix-mobile").addClass("sticky");
              $(".section-main-product-rocket").css("z-index", "999");
          }
          else {
              $(".buy-buttons-fix-mobile").removeClass("sticky");
              $(".section-main-product-rocket").css("z-index", "1");
          }
        }
      });
    }
  }
});


// browser details

function getBroswerDetails() {
  // Checking the user's OS and Browser
  if ((navigator.userAgent).includes("Android")) {
    document.querySelector("html").classList.add("android");
  } else if ((navigator.userAgent).includes("Mac")) {
    document.querySelector("html").classList.add("mac");
  } else {
    document.querySelector("html").classList.add("windows");
  }
  //-- Browser --//
  var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
  var isFirefox = typeof InstallTrigger !== 'undefined';
  var isSafari = /constructor/i.test(window.HTMLElement) || (function(p) {
    return p.toString() === "[object SafariRemoteNotification]";
  })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));
  var isIE = /*@cc_on!@*/ false || !!document.documentMode;
  var isEdge = !isIE && !!window.StyleMedia;
  var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
  var isEdgeChromium = isChrome && (navigator.userAgent.indexOf("Edg") != -1);
  var isBlink = (isChrome || isOpera) && !!window.CSS;
  if (isFirefox) {
    document.querySelector("html").classList.add("isFirefox")
  } else if (isChrome) {
    document.querySelector("html").classList.add("isChrome")
  } else if (isSafari) {
    document.querySelector("html").classList.add("isSafari")
  } else if (isOpera) {
    document.querySelector("html").classList.add("isOpera")
  } else if (isIE) {
    document.querySelector("html").classList.add("isIE")
  } else if (isEdge) {
    document.querySelector("html").classList.add("isEdge")
  } else if (isEdgeChromium) {
    document.querySelector("html").classList.add("isEdgeChromium")
  } else {
    document.querySelector("html").classList.add("isBlink")
  }
}
getBroswerDetails();


$(".section-main-product-rocket summary.cc-accordion-item__title").click(function(){
  // Only close other accordion items within the same .cc-accordion container, not across different accordion blocks
  var $clickedAccordionContainer = $(this).closest('.cc-accordion');
  var $clickedItem = $(this).closest('.cc-accordion-item');

  // Close other items only within the same accordion container
  $clickedAccordionContainer.find('.cc-accordion-item').not($clickedItem).each(function() {
    var $item = $(this);
    if ($item.attr('open') || $item.hasClass('is-open')) {
      // Properly close with icon toggle
      $item.removeAttr("open");
      $item.removeClass("is-open");
      $item.find('.cc-accordion-item__title__plus').show();
      $item.find('.cc-accordion-item__title__minus').hide();
    }
  });
});

$(".promotion-block__image").parent(".product-block").addClass("promotion-block-main");



// scrollable

function x_scroll(p) {
  p.querySelectorAll('.scrollable_').forEach( x => {
    x.addEventListener( 'scroll', e => {
      let scrollable = e.currentTarget;
      let arrows = scrollable.parentElement.querySelectorAll('.arrows svg, .arrow svg');

      if (arrows.length === 0) return;

      let first_item = scrollable.children[0];
      let last_item = scrollable.children[scrollable.children.length - 1];

      let origin = scrollable.getBoundingClientRect().x;
      let visible = origin + scrollable.getBoundingClientRect().width;

      if (first_item.getBoundingClientRect().x >= origin) arrows[0].classList.add('disabled');
      else arrows[0].classList.remove('disabled');

      if (last_item.getBoundingClientRect().x + last_item.getBoundingClientRect().width < visible + 1) arrows[1].classList.add('disabled');
      else arrows[1].classList.remove('disabled');
    } );
  } );

  p.querySelectorAll('.arrows svg, .arrow svg').forEach( x => {
    x.addEventListener( 'click', e => {
      e.preventDefault();

      let arrow = e.currentTarget;
      let parent = arrow.parentElement;

      if ( arrow.classList.contains('disabled') ) return;

      let scrollable;
      let stop = false;

      while (!scrollable) {
        scrollable = parent.querySelector('.scrollable_');
        parent = parent.parentElement;
      }

      let origin = scrollable.getBoundingClientRect().x;
      let visible = origin + scrollable.getBoundingClientRect().width;

      for (let i of scrollable.children) {
        if (stop) break;

        let start = i.getBoundingClientRect().x;
        let end = start + i.getBoundingClientRect().width;

        if ( arrow.dataset.factor == 1 && (start >= visible || end > visible + 1) ) {
          scrollable.scrollLeft += start - origin;
          stop = true;
        }

        else if (arrow.dataset.factor == -1 && origin - end <= 16) {
          scrollable.scrollLeft -= visible - end;
          stop = true;
        }
      }
    } );
  } );
}


x_scroll(document);



// language selector

document.querySelectorAll('#lang-list-footer .disclosure-list__option').forEach( a => {
  a.addEventListener( 'click', e => {
    localStorage.setItem('language', a.dataset.value);
    gtag( 'event', 'select_language', { iso_code: a.dataset.value } ); // analytics
  } );
} );


// cart

let terms_input = document.querySelector('.termsagreement input');

if (terms_input) {
  if ( sessionStorage.getItem('terms_accepted') === 'true' ) terms_input.checked = true;

  terms_input.addEventListener( 'change', e => {
    sessionStorage.setItem('terms_accepted', e.currentTarget.checked);
  } );
}



// consentmo

let cb_visible = false;

const cb_observer = new MutationObserver( (r, o) => {
  let accept_button = document.querySelector('.cc-btn-accept-selected');

  if (cb_visible || !accept_button) return;
  cb_visible = true;

  let checkboxes = document.querySelectorAll('.isense-cc-settings-dialog input[type = "checkbox"]:not(#strict-cookies-checkbox)');

  checkboxes.forEach( x => {
    x.addEventListener( 'change', e => {
      accept_button.textContent = !Array.from(checkboxes).some(y => y.checked) ? 'Reject' : accept_button.ariaLabel;
    } );
  } );
} );


cb_observer.observe( document.body, { childList: true } );


// Cart quantity control fix - prevent negative quantities
(function() {
  // Function to update button states based on quantity
  function updateQuantityButtons(quantityContainer) {
    const input = quantityContainer.querySelector('input[type="text"]');
    const decreaseBtn = quantityContainer.querySelector('.quantity-down');
    const increaseBtn = quantityContainer.querySelector('.quantity-up');

    if (!input || !decreaseBtn) return;

    const currentQty = parseInt(input.value) || 1;
    const maxQty = input.dataset.max ? parseInt(input.dataset.max) : null;

    // Disable/enable decrease button
    if (currentQty <= 1) {
      decreaseBtn.classList.add('unusable');
    } else {
      decreaseBtn.classList.remove('unusable');
    }

    // Disable/enable increase button if max quantity is set
    if (increaseBtn) {
      if (maxQty && currentQty >= maxQty) {
        increaseBtn.classList.add('unusable');
      } else {
        increaseBtn.classList.remove('unusable');
      }
    }
  }

  // Intercept click events BEFORE theme.js processes them
  document.addEventListener('click', function(e) {
    const target = e.target.closest('.quantity-down');
    if (!target) return;

    const quantityContainer = target.closest('.quantity');
    if (!quantityContainer) return;

    const input = quantityContainer.querySelector('input[type="text"]');
    if (!input) return;

    const currentQty = parseInt(input.value) || 1;

    // Prevent click if quantity is already 1
    if (currentQty <= 1) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }
  }, true); // Use capture phase to intercept before jQuery

  // Monitor input changes to update button states
  document.addEventListener('change', function(e) {
    if (e.target.matches('.quantity input[type="text"]')) {
      const quantityContainer = e.target.closest('.quantity');
      if (quantityContainer) {
        updateQuantityButtons(quantityContainer);
      }
    }
  });

  document.addEventListener('input', function(e) {
    if (e.target.matches('.quantity input[type="text"]')) {
      const quantityContainer = e.target.closest('.quantity');
      if (quantityContainer) {
        updateQuantityButtons(quantityContainer);
      }
    }
  });

  // Initial setup for all quantity controls on page load
  function initializeQuantityButtons() {
    const quantityContainers = document.querySelectorAll('.quantity');
    quantityContainers.forEach(function(container) {
      updateQuantityButtons(container);
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(initializeQuantityButtons, 100);
    });
  } else {
    setTimeout(initializeQuantityButtons, 100);
  }

  // Re-initialize after cart updates
  const cartObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        initializeQuantityButtons();
      }
    });
  });

  // Observe cart changes
  const cartContainer = document.querySelector('.cart-item-list');
  if (cartContainer) {
    cartObserver.observe(cartContainer, { childList: true, subtree: true });
  }
})();